module.exports = __webpack_public_path__ + "media/newstyle/images/icon-arrow-left-pagination-4aaafbce0c39f87e1dedd8bb31f2d0c7.svg";